import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import { HoverableImageLink } from "~/components/about-us/HoverableImageLink";
import { HeroStyle2 } from "~/components/HeroStyle2";
import { HomeConsultForm } from "~/components/home/HomeConsultForm";
import {
	Locale,
	useLocalization,
} from "~/components/localization/LocalizationProvider";
import styles from "../live-seo-page.module.css";

type OrthoInfoCard = {
	label: string;
	image: string;
	to: string;
	position?: string;
};

type OrthoInfoLocalization = {
	title: string;
	heading: string;
	paragraphs: string[];
	cards: OrthoInfoCard[];
};

const orthoInfoLocalization = {
	[Locale.EN]: {
		title: "Orthodontic Info",
		heading: "Transforming Your Smile Together",
		paragraphs: [
			"To get the best smile from Miami Orthodontic Specialists, you’ll need to do your part to take care of teeth, gums, and orthodontics appliances.",
			"Dr. Garcia-Paul and Dr. Chinchilla can’t wait to help you transform your new smile.",
		],
		cards: [
			{
				label: "FAQs",
				image: "/miami-ortho-6.jpg",
				to: "/faqs/",
				position: "center",
			},
			{
				label: "Ortho Emergencies",
				image: "/miami-ortho-15.jpg",
				to: "/ortho-emergencies/",
				position: "center",
			},
			{
				label: "Ortho Care",
				image: "/miami-ortho-10.jpg",
				to: "/ortho-care/",
				position: "center",
			},
			{
				label: "Life With Braces",
				image: "/group-of-smiling-teens.jpg",
				to: "/life-with-braces/",
				position: "center",
			},
		],
	},
	[Locale.ES]: {
		title: "Información de ortodoncia",
		heading: "Transformando tu sonrisa juntos",
		paragraphs: [
			"Para lograr la mejor sonrisa con Miami Orthodontic Specialists, tendrás que hacer tu parte cuidando tus dientes, encías y aparatos de ortodoncia.",
			"La Dra. Garcia-Paul y el Dr. Chinchilla están listos para ayudarte a transformar tu nueva sonrisa.",
		],
		cards: [
			{
				label: "Preguntas frecuentes",
				image: "/miami-ortho-6.jpg",
				to: "/faqs/",
				position: "center",
			},
			{
				label: "Emergencias de ortodoncia",
				image: "/miami-ortho-15.jpg",
				to: "/ortho-emergencies/",
				position: "center",
			},
			{
				label: "Cuidado de ortodoncia",
				image: "/miami-ortho-10.jpg",
				to: "/ortho-care/",
				position: "center",
			},
			{
				label: "Vida con brackets",
				image: "/group-of-smiling-teens.jpg",
				to: "/life-with-braces/",
				position: "center",
			},
		],
	},
} satisfies Record<Locale, OrthoInfoLocalization>;

export function OrthoInfoPage() {
	const getLocalization = useLocalization(orthoInfoLocalization);

	return (
		<Flex direction="column">
			<HeroStyle2
				heroImageUrl="/miami-ortho-9.jpg"
				title={getLocalization("title")}
				backgroundPosition="center"
			/>
			<Box className={styles.orthoInfoIntroBand}>
				<Flex className={styles.orthoInfoIntroInner} direction="column">
					<Heading as="h2" className={styles.orthoInfoHeading}>
						{getLocalization("heading")}
					</Heading>
					{getLocalization("paragraphs").map((paragraph) => (
						<Text as="p" className={styles.orthoInfoCopy} key={paragraph}>
							{paragraph}
						</Text>
					))}
				</Flex>
			</Box>
			<Box className={styles.orthoInfoCardsBand}>
				<Grid
					columns={{ initial: "1", md: "2" }}
					className={styles.orthoInfoCardsGrid}
				>
					{getLocalization("cards").map((card) => (
						<Box className={styles.orthoInfoCard} key={card.to}>
							<HoverableImageLink
								imageUrl={card.image}
								label={card.label}
								to={card.to}
								backgroundPosition={card.position}
							/>
						</Box>
					))}
				</Grid>
			</Box>
			<Box className={styles.formWrap}>
				<HomeConsultForm />
			</Box>
		</Flex>
	);
}
